<template>
  <div id="SelectSeat">
    <div class="title">select map</div>
    <div class="buttons">
      <div
        class="button"
        :class="{ active: activeMap == 'full' }"
        @click.prevent="(e) => $emit('changeMap', 'full')"
      >
        full map
      </div>
      <div
        class="button"
        :class="{ active: activeMap == 'courtside' }"
        @click.prevent="(e) => $emit('changeMap', 'courtside')"
      >
        courtside
      </div>
    </div>
    <div class="title">select your seats</div>
    <div class="middle">
      <div class="left">
        <div class="label">seat type:</div>
        <div class="dropdown">
          <div
            class="display"
            @click="(seatMenu = !seatMenu), (numberMenu = false)"
          >
            <div class="item">
              <div
                v-if="!lines"
                class="hex"
                :style="{ 'background-color': hex }"
              />
              <div
                v-else
                class="hex"
                :style="{
                  background: `repeating-linear-gradient(155deg, ${hex}, #3a4038 4px, ${hex} 8px, #3a4038 4px)`,
                }"
              />
              {{ activeSection }}
            </div>
            <img src="@/assets/images/seating/down-arrow-small.svg" />
          </div>
          <div class="menu" :class="{ active: seatMenu }">
            <div class="menuInner">
              <div class="scroller">
                <template v-for="item in map">
                  <div
                    v-if="!item.lines"
                    :key="item.hex"
                    class="scroller-item"
                    :class="{ active: item.mapTitle == activeSection }"
                    @click.prevent="
                      (e) => $emit('changeSection', item.mapTitle)
                    "
                    @click="seatMenu = false"
                  >
                    <div
                      class="seatHex"
                      :style="{ 'background-color': item.hex }"
                    />
                    <span>{{ item.mapTitle }}</span>
                  </div>
                  <div
                    v-else
                    :key="item.hex"
                    class="scroller-item"
                    :class="{ active: item.mapTitle == activeSection }"
                    @click.prevent="
                      (e) => $emit('changeSection', item.mapTitle)
                    "
                    @click="seatMenu = false"
                  >
                    <div
                      class="seatHex"
                      :style="{
                        background: `repeating-linear-gradient(155deg, ${item.hex}, #3a4038 5px, ${item.hex} 6px, #3a4038 5px)`,
                      }"
                    />
                    <span>{{ item.mapTitle }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="label">amount of seats:</div>
        <div class="dropdown">
          <div
            class="display"
            @click="(numberMenu = !numberMenu), (seatMenu = false)"
          >
            <div class="item">{{ numberOfSeats }}</div>
            <img src="@/assets/images/seating/down-arrow-small.svg" />
          </div>
          <div class="menu" :class="{ active: numberMenu }">
            <div class="inner">
              <span
                @click="(numberOfSeats = 1), (numberMenu = false)"
                :class="{ active: numberOfSeats == 1 }"
                >1</span
              >
              <span
                @click="(numberOfSeats = 2), (numberMenu = false)"
                :class="{ active: numberOfSeats == 2 }"
                >2</span
              >
              <span
                @click="(numberOfSeats = 3), (numberMenu = false)"
                :class="{ active: numberOfSeats == 3 }"
                >3</span
              >
              <span
                @click="(numberOfSeats = 4), (numberMenu = false)"
                :class="{ active: numberOfSeats == 4 }"
                >4</span
              >
              <span
                @click="(numberOfSeats = 5), (numberMenu = false)"
                :class="{ active: numberOfSeats == 5 }"
                >5</span
              >
              <span
                @click="(numberOfSeats = 6), (numberMenu = false)"
                :class="{ active: numberOfSeats == 6 }"
                >6</span
              >
              <span
                @click="(numberOfSeats = 7), (numberMenu = false)"
                :class="{ active: numberOfSeats == 7 }"
                >7</span
              >
              <span
                @click="(numberOfSeats = 8), (numberMenu = false)"
                :class="{ active: numberOfSeats == 8 }"
                >8</span
              >
              <span
                @click="(numberOfSeats = 9), (numberMenu = false)"
                :class="{ active: numberOfSeats == 9 }"
                >9</span
              >
              <span
                @click="(numberOfSeats = 10), (numberMenu = false)"
                :class="{ active: numberOfSeats == 10 }"
                >10</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="side">
        <div class="side__title"><span>before</span> deadline</div>
        <div class="side__info">
          <div class="item">
            <div class="header">full season</div>
            <div class="number">${{ itemCalc("beforeFull") }}</div>
          </div>
          <div class="item">
            <div class="header">half season</div>
            <div class="number">${{ itemCalc("beforeHalf") }}</div>
          </div>
        </div>
      </div>
      <div class="side">
        <div class="side__title"><span>after</span> deadline</div>
        <div class="side__info">
          <div class="item">
            <div class="header">full season</div>
            <div class="number">${{ itemCalc("afterFull") }}</div>
          </div>
          <div class="item">
            <div class="header">half season</div>
            <div class="number">${{ itemCalc("afterHalf") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapData } from "./mapData";
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "SelectSeat",
  props: ["activeSection", "activeMap"],
  emits: ["changeSection", "changeMap"],
  data() {
    return {
      map: mapData(),
      numberOfSeats: 2,
      hex: null,
      lines: false,
      numberMenu: false,
      seatMenu: false,
    };
  },
  setup() {
    const store = useStore();

    // State
    const state = reactive({
      purl: computed(() => store.getters["purl/getAccount"]),
    });

    return { ...toRefs(state) };
  },
  watch: {
    activeSection(newValue, oldValue) {
      this.hexSetter(newValue);
    },
    purl(to, from) {
      if (to.accounts) {
        this.numberOfSeats = to.accounts[0].numOfSeats;
      }
    },
  },
  mounted() {
    this.hexSetter(this.activeSection);
    setTimeout(() => {
      if (this.purl.accounts) {
        this.numberOfSeats = this.purl.accounts[0].numOfSeats;
      }
    }, 1000);
  },
  methods: {
    currency(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    hexSetter(section) {
      this.map.forEach((item) => {
        if (item.mapTitle == section) {
          this.lines = item.lines;
          this.hex = item.hex;
        }
      });
    },
    itemCalc(deadline) {
      let itemNumber = 0;
      this.map.forEach((item) => {
        if (item.mapTitle == this.activeSection) {
          itemNumber = this.currency(
            parseInt(item[deadline]) * this.numberOfSeats
          );
        }
      });
      return itemNumber;
    },
  },
};
</script>

<style lang="scss" scoped>
#SelectSeat {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  .title {
    font-family: DINPro-CondBlack;
    font-weight: 900;
    font-size: 18px;
    line-height: 11px;
    letter-spacing: normal;
    color: #ffffff;
    text-transform: uppercase;
    @media (max-width: 992px) {
      font-size: 16px;
      line-height: 19px;
    }
  }
  .buttons {
    display: flex;
    flex-direction: row;
    margin: 15px 0 22px 0;
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 45px;
      width: 140px;
      border: 4px solid #ffffff;
      font-family: Abolition;
      font-weight: normal;
      font-size: 20px;
      letter-spacing: normal;
      line-height: 22px;
      color: #ffffff;
      text-transform: uppercase;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      &:first-child {
        margin-right: 10px;
      }
      &.active {
        color: #000000;
        background: #ffffff;
        transition: all 0.3s ease-in-out;
      }
    }
  }
  .middle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin: 28px 0 45px 0;
    @media (max-width: 992px) {
      flex-direction: column;
    }
    .left {
      width: calc(100% - 150px);
      @media (max-width: 992px) {
        width: 100%;
      }
      .display {
        padding: 0 13.74px 0 32px;
        @media (max-width: 992px) {
          padding: 0 18.2px 0 32px;
        }
        .hex {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 13px;
          @media (max-width: 992px) {
            width: 12px;
          }
        }
      }
      .dropdown {
        .menu {
          @media (max-width: 992px) {
            z-index: 4;
          }
        }
      }
      .menu {
        &Inner {
          display: flex;
          flex-direction: column;
          height: 100%;
          max-height: 266px;
          overflow: scroll;
          .scroller {
            height: fit-content;
            padding: 6px 7px;
            &-item {
              display: flex;
              flex-direction: row;
              align-items: center;
              &.active {
                span {
                  color: #de1e35;
                }
              }
              .seatHex {
                height: 20px;
                width: 12px;
                border-radius: 2px;
                margin-right: 7px;
              }
              span {
                font-family: Abolition;
                font-weight: normal;
                font-size: 22px;
                letter-spacing: 0;
                line-height: 27px;
                text-transform: uppercase;
                @media (max-width: 1200px) {
                  font-size: 18px;
                }
                @media (max-width: 992px) {
                  font-size: 22px;
                }
                @media (max-width: 400px) {
                  font-size: 18px;
                }
              }
            }
          }
        }
      }
    }
    .right {
      width: 130px;
      @media (max-width: 992px) {
        width: 100%;
        margin-top: 15px;
      }
      .display {
        padding: 0 13.74px 0 15px;
        @media (max-width: 992px) {
          padding: 0 18.2px 0 32px;
        }
        .dropdown {
          .menu {
            @media (max-width: 992px) {
              z-index: 3;
            }
          }
        }
      }
    }
    .left,
    .right {
      display: flex;
      flex-direction: column;
      .label {
        font-family: Abolition;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: normal;
        color: #ffffff;
        text-transform: uppercase;
        margin-bottom: 10px;
      }
      .dropdown {
        position: relative;
        width: 100%;
        cursor: pointer;
        .display {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 68px;
          background: linear-gradient(180deg, #fcfcfc 0%, #fafafa 100%);
          box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
          @media (max-width: 992px) {
            height: 62px;
          }
          .item {
            font-family: Abolition;
            font-weight: normal;
            font-size: 22px;
            letter-spacing: 0;
            line-height: 27px;
            text-transform: uppercase;
            @media (max-width: 1200px) {
              font-size: 18px;
            }
            @media (max-width: 992px) {
              font-size: 22px;
            }
            @media (max-width: 400px) {
              font-size: 18px;
            }
          }
        }
        .menu {
          position: absolute;
          left: 0;
          width: 100%;
          overflow: hidden;
          border: 1px solid #b0b7bc;
          background-color: #ffffff;
          box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.2);
          max-height: 0;
          transition: all 0.3s ease-in-out;
          @media (min-width: 992px) {
            top: 0;
          }
          @media (max-width: 992px) {
            bottom: 0;
          }
          &.active {
            @media (min-width: 992px) {
              top: -266px;
              max-height: 266px;
              transition: all 0.3s ease-in-out;
            }
            @media (max-width: 992px) {
              bottom: -266px;
              max-height: 266px;
              transition: all 0.3s ease-in-out;
            }
          }
          .inner {
            display: flex;
            flex-direction: column;
            padding: 5px 0;
            height: fit-content;
            min-height: 266px;
            width: 100%;
            span {
              font-family: Abolition-Rough;
              font-weight: normal;
              font-size: 16px;
              line-height: 26px;
              letter-spacing: 0.2px;
              color: #000000;
              text-align: center;
              width: 100%;
              cursor: pointer;
              &.active {
                color: #de1e35;
              }
            }
          }
        }
      }
    }
  }
  .bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    @media (max-width: 767px) {
      flex-direction: column;
    }
    .side {
      display: flex;
      flex-direction: column;
      width: calc(50% - 40px);
      @media (max-width: 767px) {
        width: 100%;
        &:first-child {
          margin-bottom: 25px;
        }
      }
      &__title {
        font-family: DINPro-CondBlack;
        font-weight: 900;
        font-size: 18px;
        line-height: 11px;
        letter-spacing: normal;
        color: #cccccc;
        text-transform: uppercase;
        margin-bottom: 20px;
        span {
          color: #ffffff;
        }
      }
      &__info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        @media (max-width: 767px) {
          justify-content: flex-start;
        }
        .item {
          display: flex;
          flex-direction: column;
          @media (max-width: 767px) {
            &:first-child {
              margin-right: 55px;
            }
          }
          .header {
            font-family: Abolition;
            font-weight: normal;
            font-size: 16px;
            line-height: 19px;
            letter-spacing: normal;
            color: #cccccc;
            text-transform: uppercase;
            margin-bottom: 10px;
          }
          .number {
            font-family: DINPro-CondBlack;
            font-weight: 900;
            font-size: 32px;
            line-height: 32px;
            letter-spacing: normal;
            color: #ffffff;
            @media (max-width: 1200px) {
              font-size: 26px;
              line-height: 26px;
            }
          }
        }
      }
    }
  }
}
</style>